<template>
  <div class="diadin">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input style="width: 300px;" clearable :placeholder="`${$t('menu.OrderNumber')}/${$t('menu.ContractNumber')}`"
          v-model="formInline.title"></el-input>
      </el-form-item>
      <!-- <el-form-item >
          <el-select v-model="formInline.staue" placeholder="订单类型" clearable>
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item,index) in staue" :key="index" :label="item.name" :value="item.id"></el-option>
         
          </el-select>
        </el-form-item> -->
        
        <el-form-item>
        <el-select v-model="orderType" :placeholder="$t('menu.Paymentmethod')" clearable>
          <!-- <el-option label="全部" value=""></el-option> -->
          <el-option v-if="inle == 'zh'" v-for="(item, index) in odtype" :key="index" :label="item.dictLabel"
            :value="item.dictValue"></el-option>
          <el-option v-if="inle !== 'zh'" v-for="(item, index) in odtype" :key="index" :label="item.dictLabelEn"
            :value="item.dictValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="formInline.type" :placeholder="$t('menu.Paymentmethod')" clearable>
          <!-- <el-option label="全部" value=""></el-option> -->
          <el-option v-if="inle == 'zh'" v-for="(item, index) in jsfs" :key="index" :label="item.dictLabel"
            :value="item.dictValue"></el-option>
          <el-option v-if="inle !== 'zh'" v-for="(item, index) in jsfs" :key="index" :label="item.dictLabelEn"
            :value="item.dictValue"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item >
          <el-col :span="11">
      <el-date-picker type="date" placeholder="开始时间" v-model="formInline.data1" style="width: 100%;"></el-date-picker>
    </el-col>
    <el-col class="line" :span="2">-</el-col>
    <el-col :span="11">
      <el-date-picker placeholder="结束时间" v-model="formInline.data2" style="width: 100%;"></el-date-picker>
    </el-col>
        </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ $t('menu.search') }}</el-button>
        <!-- <el-button>重置</el-button> -->
      </el-form-item>
    </el-form>
    <div class="bonntbot">
      <el-tabs v-model="action" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in staue" :key="index"
          :label="item.num > 0 ? item.name + '(' + item.num + ')' : item.name" :name="item.id"></el-tab-pane>


      </el-tabs>
      <div class="bonntbota">
        <el-button type="text" @click="downOrder">{{ $t('menu.ExportOrder') }}</el-button>
        <el-button type="text" @click="downOrderDetails">{{ $t('menu.ExportDetails') }}</el-button>
      </div>

    </div>
    <el-table  empty-text=" " :data="mation" style="width: 100%" border highlight-current-row @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="65" >
      </el-table-column>
      <el-table-column prop="pc" :label="$t('menu.OrderNumber')" width="200">
        <template slot-scope="scope">
        <div>  {{ scope.row.po.orderNumber }}</div>
        <div v-if=" scope.row.po.orderType==1">
          {{ $t('menu.erlunpej') }}
        </div>
         <div v-if=" scope.row.po.orderType==2">
          {{ $t('menu.erlunzhengc') }}  
        </div>
         <div v-if=" scope.row.po.orderType==3">
          {{ $t('menu.silunpej') }}
        </div>
         <div v-if=" scope.row.po.orderType==4">
          {{ $t('menu.silunzhengc') }}
        </div>
         <div v-if=" scope.row.po.orderType==9000">
          {{ $t('menu.zhoubianq') }}
        </div>
       
        </template>
      </el-table-column>
      <el-table-column prop="orderNumber" :label="$t('menu.ContractNumber')">
        <template slot-scope="scope">
          {{ scope.row.po.saleNumber }}
        </template>
      </el-table-column>
       <el-table-column prop="shippingMethod" :label="$t('menu.FreightMode')">
        <template slot-scope="scope">
          {{ accTypeIdttac(scope.row.po.shippingMethod) }}
        </template>
      </el-table-column>
      
      <el-table-column prop="cjh" :label="$t('menu.Currency')" width="90">
        <template slot-scope="scope">
          {{ scope.row.po.currencyType }}
        </template>
      </el-table-column>
      <el-table-column prop="vin" :label="$t('menu.PurchaseAmount')" width="100">
        <template slot-scope="scope">
          {{ scope.row.po.orderAmount }}
        </template>
      </el-table-column>
     
       <el-table-column prop="discountAmount" :label="$t('menu.yueikou')" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.po.discountAmount!==null">
          <div>
            {{ scope.row.po.discountAmount }}
          </div>
          <div>
            {{accTypeIdtt(scope.row.po.accTypeId)  }}
          </div>
          
          </div>
          <div v-else>
           0
          </div>
        </template>
      </el-table-column>
       <el-table-column prop="vin" :label="$t('menu.zhuanggjine')" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.po.discountAmount!==null">
 
            {{ ccbaopl(scope.row.po.orderAmount-scope.row.po.discountAmount) }}
        
         
          
          </div>
          <div v-else>
          {{ scope.row.po.orderAmount }}
          </div>
          
        </template>
      </el-table-column>
      
       <el-table-column prop="xsd" :label="$t('menu.zhuangxjindu')" v-if="typa==1">
        <template slot-scope="scope">
          <div>
            {{ tcintow(scope.row.po.boxQuantity/scope.row.po.quantity ) }}%
          </div>
          <div>
            {{ $t('menu.Quantity') }}： {{ scope.row.po.boxQuantity }} / {{ scope.row.po.quantity }}
          </div>
          <div>
            {{ $t('menu.Kind') }}： <span>{{ 
              scope.row.po.boxTypeQuantity}}</span> /{{scope.row.po.typeQuantity }} 
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="xsd" :label="$t('menu.DeliveryProgress')">
        <template slot-scope="scope">
          <div>
            {{ tcintow(scope.row.po.shippedQuantity/scope.row.po.quantity ) }}%
          </div>
          <div>
            {{ $t('menu.Quantity') }}： {{ scope.row.po.shippedQuantity }} / {{ scope.row.po.quantity }}
          </div>
          <div>
            {{ $t('menu.Kind') }}： <span>{{ 
              scope.row.po.shippedTypeQuantity}}</span> /{{scope.row.po.typeQuantity }} 
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="zt" :label="$t('menu.Paymentmethod')">
        <template slot-scope="scope">
          {{ jstype(scope.row.po.paymentMethod) }}
        </template>
      </el-table-column>

      <el-table-column prop="rk" :label="$t('menu.State')" width="80">
        <template slot-scope="scope">
          {{ formatStatus(scope.row.po.status) }}
        </template>
      </el-table-column>
      <el-table-column prop="xs" :label="$t('menu.OrderTime')" width="170">
        <template slot-scope="scope">
          {{ scope.row.po.orderTime.slice(0, 10) }}{{ ' '
          }}{{ scope.row.po.orderTime.slice(11, 19) }}
        </template>
      </el-table-column>
      <el-table-column width="80">
        <template slot="header" slot-scope="scope">
          <div>{{ $t('menu.Operation') }}</div>
        </template>
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleEdit(2, scope.row)">{{ $t('menu.Details') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total,sizes, prev, pager, next" :total="totale">
      </el-pagination>
    </div>

    <div></div>
  </div>
</template>

<script>
import { pomyPos, querytype, pageSumMyPo, exportMyPo, exportMyPoDetailsa,listAccType } from '../../api/api'

export default {
  data () {
    return {
      action: '99',
      actlist:[],
      staue: [
        {
          name: this.$t('menu.All'),
          num: 0,
          id: '99',
        },
        
        {
          name: this.$t('menu.PendingReview'),
          num: 0,
          id: '1,5',
        },
          {
          name:this.$t('menu.beihuozhong'),
          num: 0,
          id: '6,7,8',
        },
        {
          name: this.$t('menu.PendingShipment'),
          num: 0,
          id: '2',
        },
        {
          name: this.$t('menu.UnderDelivery'),
          num: 0,
          id: '3',
        },
        {
          name: this.$t('menu.Completed'),
          num: 0,
          id: '4',
        },
       
        
        // {
        //   name: '待支付',
        //   num: 2,
        //   id: '0',
        // },
        {
          name: this.$t('menu.Rejected'),
          num: 0,
          id: '-2',
        },
        {
          name: this.$t('menu.Cancelled'),
          num: 0,
          id: '-1',
        },
      ],
      jsfs: [],
      currentPage3: 1,
      pageSize: 10,
      totale: 3,
      orderType:'',
      mation: [], //列表
      formInline: {
        title: '',
        startTime: '',
        endTime: '',
        contact: '',
        category: '',
        type: '',
        staue: '',
        data1: '',
        data2: '',
        
      },
      inle: 'zh',
      odtype:'',
      accountList:[],
      typa:2,
      hytype:[],
    }
  },
  created () {
    let a = sessionStorage.getItem('i18n')
    this.typa=sessionStorage.getItem('platform')
    this.inle = a
    this.querytyp()
    this.querytypa()
    this.action = '99'
    this.biao()
    this.getListAccType()
  },
  methods: {
       ccbaopl(e){
    let a = 0
    if(e>0){
      a=e.toFixed(2)
    }
 
    
    return a
   },
   
    accTypeIdttac(e){
      let a = ''
      this.hytype.forEach(z=>{
        if(e==z.dictValue){
          if(this.inle=='zh'){
            a=z.dictLabel
          }else{
            a=z.dictLabelEn
          }
        }
      })
    
      
      return a
    },
     accTypeIdtt(e){
      let a = ''
      this.accountList.forEach(z=>{
        if(e==z.id){
          if(this.inle=='zh'){
            a=z.name
          }else{
            a=z.nameEn
          }
        }
      })
      console.log(this.inle);
      
      return a
    },
      getListAccType () {
      listAccType().then(r => {
        this.accountList = r.data.data

      })
    },
    downOrderDetails () {
      let obj = {
        status: this.action
      }
      let a  = []
      this.actlist.forEach(e=>{
        a.push(e.po.id)
      })
      exportMyPoDetailsa(obj,a).then(res => {
        // const link = document.createElement('a')
        // let blob = new Blob([res.data], { type: 'application/x-www-form-urlencoded' })
        // link.style.display = 'none'
        // link.href = URL.createObjectURL(blob)
        // link.setAttribute('download', '我的采购订单明细.xlsx')
        // document.body.appendChild(link)
        // link.click() //触发下载
        // document.body.removeChild(link)

        // 创建一个URL对象，将Blob对象包装成一个临时的可访问URL
        const url = window.URL.createObjectURL(new Blob([res.data]));
        // 创建一个<a>元素，用于模拟点击下载文件
        const link = document.createElement('a');
        link.href = url;
        // 设置下载文件的名称
        link.setAttribute('download', '我的采购订单明细.xlsx');
        // 将<a>元素添加到文档中
        document.body.appendChild(link);
        // 模拟点击下载
        link.click();
        // 移除<a>元素
        // link.remove();
        // 释放创建的URL对象，避免内存泄漏
        window.URL.revokeObjectURL(url);
      })
    },
    downOrder () {
      let obj = {
        status: this.action
      }
      exportMyPo(obj).then(res => {
        // const link = document.createElement('a')
        // let blob = new Blob([res.data], { type: 'application/x-www-form-urlencoded' })
        // link.style.display = 'none'
        // link.href = URL.createObjectURL(blob)
        // link.setAttribute('download', '我的采购订单.xlsx')
        // document.body.appendChild(link)
        // link.click() //触发下载
        // document.body.removeChild(link)
        // 创建一个URL对象，将Blob对象包装成一个临时的可访问URL
        const url = window.URL.createObjectURL(new Blob([res.data]));
        // 创建一个<a>元素，用于模拟点击下载文件
        const link = document.createElement('a');
        link.href = url;
        // 设置下载文件的名称
        link.setAttribute('download', '我的采购订单.xlsx');
        // 将<a>元素添加到文档中
        document.body.appendChild(link);
        // 模拟点击下载
        link.click();
        // 移除<a>元素
        // link.remove();
        // 释放创建的URL对象，避免内存泄漏
        window.URL.revokeObjectURL(url);
      })
    },
    async biao () {
      let a = ''
      if (this.action == '99') {
        a = ''
      } else {
        a = this.action
      }
      console.log(123123,this.orderType);
      
      let param = new URLSearchParams()
      let status = a
      const { data: res } = await pomyPos(
        param,
        this.currentPage3,
        this.pageSize,
        status,
        this.formInline.type,
        this.formInline.title,
        // this.formInline.data1,
        // this.formInline.data2,
        this.orderType
      )

      this.mation = res.data.list
      this.totale = res.data.total
      this.numlist()
    },
    async numlist () {

      let param = {}
      const { data: res } = await pageSumMyPo(param)
      let a = this.staue
      let b = 0
      let c = 0
      let dd1 = 0
      let dd2 = 0
      let dd3 = 0
      res.data.forEach(e => {
        a.forEach((z, i) => {
          if (e.status == z.id) {
            this.staue[i].num = e.sum
          } else {
            if (e.status == 5) {
              // console.log(1);

              b = e.sum
            }
            if (e.status == 1) {
              // console.log(1);

              c = e.sum
            }
             if (e.status == 6) {
              // console.log(1);

              dd1 = e.sum
            }
             if (e.status == 7) {
              // console.log(1);

              dd2 = e.sum
            }
             if (e.status == 8) {
              // console.log(1);

             dd3 = e.sum
            }
             if (z.id == '6,7,8') {
              // console.log(1);
              this.staue[i].num=dd1+dd2+dd3
          
            }
          }


        })


      })
      // this.staue[1].num = b + c
    },
    handleSelectionChange (e) { 
      console.log(e);
      this.actlist=e
      
    },
    async querytyp () {
      let param = new URLSearchParams()
      const { data: res } = await querytype(param, 't_po_payment_method')
      this.jsfs = res.data
      this.jsfs.unshift({
        dictLabel: this.$t('menu.All'),
        dictValue: '',
        dictLabelEn: this.$t('menu.All'),
      })
      this.odtype=[
        {
          dictLabel: this.$t('menu.All'),
        dictValue: '',
        dictLabelEn: this.$t('menu.All'),
        },
        { 
          dictLabel: this.$t('menu.erlunpej'),
        dictValue: '1',
        dictLabelEn: this.$t('menu.erlunpej'),
        },
        {
          dictLabel: this.$t('menu.erlunzhengc'),
        dictValue: '2',
        dictLabelEn: this.$t('menu.erlunzhengc'),
        },
         { 
          dictLabel: this.$t('menu.silunpej'),
        dictValue: '3',
        dictLabelEn: this.$t('menu.silunpej'),
        },
        {
          dictLabel: this.$t('menu.silunzhengc'),
        dictValue: '4',
        dictLabelEn: this.$t('menu.silunzhengc'),
        },
        {
          dictLabel: this.$t('menu.zhoubianq'),
        dictValue: '9000',
        dictLabelEn: this.$t('menu.zhoubianq'),
        },
       
      ]
    },
     async querytypa () {
      let param = new URLSearchParams()
      const { data: res } = await querytype(param, 't_po_shipment_method')
     
      this.hytype=res.data
    },
    handleClick (tab, event) {
      this.action = tab.name
      this.biao()
      // console.log(tab, event)
    },
    //表单点击
    handleEdit (index, row) {
      let a = sessionStorage.getItem('name')
      let b = sessionStorage.getItem('namef')
      sessionStorage.setItem('namefac1',a )
      sessionStorage.setItem('namefac2',b )
      let cc  =sessionStorage.getItem('i18n')
      if (cc == 'zh') {
        sessionStorage.setItem('name', '订单详情')
        sessionStorage.setItem('namef', 'Details')

      } else {
        sessionStorage.setItem('name', 'Details')
        sessionStorage.setItem('namef', '订单详情')
      }
    
      this.$router.push({
        path: '/orderDetails',
        query: {
          vin: row.vin,
          type: index,
          orderNumber: row.po.id,
        },
      })
    },
    //tab切换
    tabclick (i) {
      console.log(i);

      // this.action = i
      // this.biao()
    },

    //搜索
    onSubmit () {
      this.biao()
    },

    handleSizeChange (val) {
      this.pageSize = val
      console.log(`每页 ${val} 条`)
      this.biao()
    },
    handleCurrentChange (val) {
      this.currentPage3 = val
      this.biao()
    },
    jstype (e) {
      let c = ''
      let a = this.jsfs
      a.forEach((z) => {
        if (e == z.dictValue && this.inle == 'zh') {
          c = z.dictLabel
        }
        if (e == z.dictValue && this.inle !== 'zh') {
          c = z.dictLabelEn
        }
      })
      return c
    },
    tcintow(e){
      let a = e
      let b = 0
     
      
      if(e!==null&&e!==undefined){
        b=(e*100).toFixed(2)
      }
      return b
    },
    formatStatus (status) {
      if (status == -2) {
        return '拒绝'
      } else if (status == -1) {
        return this.$t('menu.Cancelled')
      } else if (status == 0) {
        return '待支付'
      } else if (status == 1) {
        return this.$t('menu.PendingReview')
      } else if (status == 2) {
        return this.$t('menu.PendingShipment')
      } else if (status == 3) {
        return this.$t('menu.UnderDelivery')
      } else if (status == 4) {
        return this.$t('menu.Completed')
      } else if (status == 5) {
        return this.$t('menu.PendingReview')
      }
       else if (status == 6) {
        return this.$t('menu.beihuozhong')
      }
       else if (status == 7) {
        return this.$t('menu.beihuozhong')
      }
       else if (status == 8) {
        return this.$t('menu.beihuozhong')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 10px;


  position: relative;


}

.bonntbota {
  position: absolute;
  right: 10px;
  top: 0;
}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.actio {
  color: #409eff;
  font-size: 16px;
  font-weight: 600;
}
</style>
